const decryptTemplate = (text, user, option = { revert: false }) => {
  const pairs = [{ value: user.firstName, key: '{{first_name}}' }, { value: user.lastName, key: '{{last_name}}' }];

  return option.revert ?
    pairs.reduce((current, pair) => current?.split(pair.value).join(pair.key), text)
    : pairs.reduce((current, pair) => current?.split(pair.key).join(pair.value), text);
};

export { decryptTemplate };